import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges, OnChanges, ElementRef, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent } from '@angular/material/legacy-autocomplete';
import { BasicWithLibelleModel } from '../../../models/basic/basicWithLibelle.model';
import * as util from '../../../constants/util';


@Component({
  selector: 'app-autocomplete-with-code-form',
  templateUrl: './autocomplete-with-code-form.component.html',
  styleUrls: ['./autocomplete-with-code-form.component.scss']
})
export class AutoCompleteWithCodeFormComponent implements OnInit, OnChanges {

  @Input() objets: BasicWithLibelleModel[];
  @Input() objet: BasicWithLibelleModel;
  @Input() selectedObjet: BasicWithLibelleModel[];
  @Input() required: boolean;
  @Input() parent: UntypedFormGroup;
  @Input() name: string;
  @Input() disabled = false;
  @Input() libelle: string;
  @Output() objetChange = new EventEmitter<BasicWithLibelleModel>();
  @ViewChild('matInput') matInput: ElementRef<HTMLInputElement>;
  public util = util;
  objetsString: string[] = [];
  filteredObjets: Observable<string[]>;
  myControl: AbstractControl;

  ca1Selected: any = null;
  @Output() ca1ChildEmit = new EventEmitter<any>();
  @Input() fieldType: string;

  constructor() {
  }

  ngOnInit(): void {
    this.reLoadObjets();
  }

  reLoadObjets(): void {
    this.objetsString = [];
    if (this.objets !== undefined) {
      for (const objet of this.objets) {
        this.objetsString.push(objet.code + '-' + objet.libelle);
      }
      this.objetsString.sort((a, b) => a.localeCompare(b));
      const validators = [];
      validators.push(forbiddenNamesValidator(this.objets));
      if (util.hasRequiredField(this.myControl)) {
        validators.push(Validators.required);
      }
      if (this.disabled) {
        this.myControl.disable();
      }
      if (this.myControl) {
        this.filteredObjets = this.myControl.valueChanges.pipe(
        startWith(null),
        map((obj: string | null) => obj ? this._filter(obj) : this.objetsString.slice(0, 30)));
        this.myControl.setValidators(validators);
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.name === "activite"){
      this.myControl = new UntypedFormControl([]);
    }else {
      if (this.parent && this.name) {
        this.myControl = this.parent.get(this.name);
      }
    }
    
    if (this.objets && this.myControl) {
      this.reLoadObjets();
      if (this.objet && this.objets.length) {
        const objet = this.objets.find(obj => obj.code === this.objet.code);
        if (objet) {
          this.myControl.setValue(objet.code + '-' + objet.libelle);
        }
      }
    }
    
  }

  /* selected event*/
  onObjetChange(event: MatAutocompleteSelectedEvent): void {
    const value = event.option.viewValue;
    const objet = this.objets.find(obj => obj.code + '-' + obj.libelle === value);
    if (objet) {
      this.getCa1(objet);
      this.objetChange.emit(objet);
    }
    this.matInput.nativeElement.blur();
    this.reLoadObjets();
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    const objSelected = this.objetsString.find(obj => obj.toLowerCase() === filterValue);
    if (objSelected){
      return this.objetsString.slice(0, 30);
    } else {
      return this.objetsString.filter(obj => obj.toLowerCase().indexOf(filterValue) >= 0).slice(0, 30);
    }
  }

  getCa1(objet: any): void {
    if (objet) {
      switch (this.fieldType) {
        case 'CA1':
          this.ca1Selected = objet;
          this.ca1ChildEmit.emit(this.ca1Selected);
          break;
      }
    }
  }

  deleteIfEmpty(): void {
    this.myControl.setValue('');
    this.objetChange.emit(null);
  }
}

export function forbiddenNamesValidator(names: BasicWithLibelleModel[]): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    // below findIndex will check if control.value is equal to one of our options or not
    if (control.value && names) {
      const index = names.findIndex(name => {
        return (name.code + '-' + name.libelle).localeCompare(control.value) === 0;
      });
      return index < 0 ? { 'forbiddenNames': { value: control.value } } : null;
    } else {
      return null;
    }
  };
}
